import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";

import { Badge, Button, cn, Col, Row } from 'twyne-new.ui';

import { Card, Property } from "@/components/reports/card";
import ConfirmationPopover from "@Components/ConfirmationPopover";
import rewardsReportStore from "@Modules/report/stores/reward";
import { formatDateTime } from "@Utils/index";

import { STATUS_MAPPER, TYPE_MAPPER } from "../utils";

import Step from "./Step";

function MarkAsPaidButton({ completionId, updateState }) {
  const handleMarkAsPaid = async e => {
    e.stopPropagation()
    updateState(completionId, 'paid')
    await rewardsReportStore.markAsPaid(completionId)
  }

  return <ConfirmationPopover
    title={<span>Mark as paid completion <i>{`[#${completionId}]`}</i></span>}
    target={<Button variant='light' size="sm" color="accent" onClick={e => e.stopPropagation()}>Mark as paid</Button>}
  >
    <p><strong>Are you sure you want mark this completion as paid?</strong></p>
    <Button color="danger" onClick={handleMarkAsPaid} block>Yes, I am sure</Button>
  </ConfirmationPopover>
}

function CompletitionCardHeader({ completion, updateState }) {
  return <div className="flex justify-between items-center">
    <div className="flex items-center">
      <Link to={`/cms/rewards/${completion?.rewardId}`} className="twy-text-accent text-md">
        {`[REWARD][#${completion?.rewardId}] - ${completion?.reward?.name}`}
      </Link>
      <span className='mx-1'>-</span>
      <span className="text-sm twy-text-base">ticket: [{completion?.id}]</span>
    </div>
    <div className="flex items-center gap-2">
      {completion?.status === 'completed' ? <MarkAsPaidButton completionId={completion?.id} updateState={updateState} /> : null}
      <small className="text-sm twy-text-base">Subscribed at: {formatDateTime(completion?.createdAt)}</small>
      <Badge className='self-center' color={STATUS_MAPPER[completion?.status]} variant='outline'>{completion?.status}</Badge>
    </div>
  </div>
}

export default function RewardCompletion({ data, updateState, className = '' }) {
  return <div className={cn('flex flex-col gap-4 max-h-[75vh] overflow-y-auto mt-4', className)}>
    {data.map((completion, idx) => <Card
      key={`${completion?.id}-${idx}`}
      sectionClass='w-full'
      title={<CompletitionCardHeader completion={completion} updateState={updateState} />}
    >
      <Row>
        <Property
          label="Reward Amount"
          value={<NumberFormat value={completion?.reward?.amount} displayType="text" thousandSeparator="," decimalSeparator="." prefix={'$'} decimalScale={2} fixedDecimalScale={true} />}
        />
        <Property
          label="Type"
          value={TYPE_MAPPER[completion?.reward?.type]}
        />
        <Property
          label="User Name"
          value={`${completion?.user?.first_name} ${completion?.user?.last_name}`}
        />
        <Property
          label="User Email"
          value={completion?.user?.email}
        />
        <Property
          label="User Phone"
          value={completion?.user?.phone}
        />
        <Property
          label="User City"
          value={completion?.user?.city}
        />
        <Property
          label="User Country"
          value={completion?.user?.country}
        />
        <Col className="flex flex-col gap-4">
          {completion?.steps?.map((step, idx) => <Step key={`${step?.id}-${idx}`} step={step} />)}
        </Col>
      </Row>
    </Card>)}
  </div>
}
